export var StorageType;
(function (StorageType) {
    StorageType["COOKIE"] = "cookie";
    StorageType["LOCAL"] = "local";
    StorageType["NONE"] = "none";
})(StorageType || (StorageType = {}));
export var Layout;
(function (Layout) {
    Layout["BUTTON"] = "button";
    Layout["TOGGLE"] = "toggle";
})(Layout || (Layout = {}));
